export default "__VITE_ASSET__B1jDK$7Y__"